<template>
  <v-card>
    <v-card-title>
      Form 35A Details
    </v-card-title>
    <v-card-text>
      <p>The id passed in was {{ itemId }}</p>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "ConnectionDetailsPanel",
  props: {
    itemId: {
      type: String,
      default: "0"
    }
  },
  data: function () {
    return {}
  },
  methods: {},
}
</script>

<style scoped>

</style>
